module.exports = "<div class=dashboard-page v-if=dashboardModuleVisible> <dashboard-content/> </div> ";